export const DATE_FORMAT = {
    FORMAT1: 'YYYY/MM/DD',
    FORMAT_SHORT_TIME: 'YYYY/MM/DD HH:mm',
    FORMAT2: 'YYYY-MM-DD',
    FORMAT3: 'YYYY年MM月',
    FORMAT4: 'YYYY年MM月DD日',
    FORMAT_FULL: 'YYYY-MM-DD HH:mm:ss',
    FORMAT_DATE_WITH_DAY: 'YYYY年MM月DD日(dd)',
    FORMAT_DATETIME_WITH_DAY: 'YYYY年MM月DD日(dd) hh:mm',
};
